import { Box, Flex, Text } from "@chakra-ui/react"
import Button from "components/UI/atoms/Button"
import Icon from "components/UI/atoms/Icon"
import { useSettings } from "providers/SettingsProvider/SettingsProvider"
import { useUI } from "providers/UIProvider"


const LaundryCommissionSettings = () => {
  const { T, toggleModal } = useUI()
  const { scheduleInterval, commission, cancelCommissions } = useSettings()

  const commissionsDataLength = cancelCommissions.length

  const renderCheckIcon = () => (
    <>
      <Flex alignItems={"center"} justifyContent="center" borderRadius={"50%"} h="23px" w={"23px"} backgroundColor="#08BA36" zIndex={1} position={"absolute"} top="-1" right={"0"}>
        <Icon
          name="checkIcon"
          iconStyles={{
            width: "15px",
            height: "15px",
            fill: "white",
          }}
        />
      </Flex>
    </>
  )

  return (
    <Flex mt={"40px"} flexDirection={"column"}>

      <Text lineHeight={"28px"} fontSize={"13px"} fontWeight="bold" color={"#000000"} >{T("laundry.commission.title")}</Text>

      <Flex mt={"10px"} gap={"30px"}>
        <Box position={"relative"}>
          {scheduleInterval && renderCheckIcon()}
          <Button
            styles={{ width: "auto", height: "56px", fontSize: "sm" }}
            variant={"solid_white"}
            text={T("laundry.commission.booking_settings")}
            onClick={() => toggleModal("reservationSettingsModal", true)}
            leftIcon={
              <Icon
                name="outlinedSetting"
                iconStyles={{
                  width: "20px",
                  height: "20px",
                  fill: "black",
                }}
              />
            }

          />
        </Box>
        <Box pos="relative">
          {commissionsDataLength > 0 && renderCheckIcon()}
          <Button
            styles={{ width: "auto", height: "56px", fontSize: "sm" }}
            variant={"solid_white"}
            text={T("laundry.commission.cancellation_fee")}
            onClick={() => toggleModal("cancelReservationCommissionModal", true)}
            leftIcon={
              <Icon
                name="calendarX"
                iconStyles={{
                  width: "20px",
                  height: "20px",
                  fill: "black",
                }}
              />
            }
          />
        </Box>
        <Box position={"relative"}>
          {commission?.commission && renderCheckIcon()}
          <Button
            styles={{ width: "auto", height: "56px", fontSize: "sm" }}
            variant={"solid_white"}
            text={T("laundry.commission.booking_fee")}
            onClick={() => toggleModal("reservationCommissionModal", true)}
            leftIcon={
              <Icon
                name="percent"
                iconStyles={{
                  width: "20px",
                  height: "20px",
                  fill: "primary",
                }}
              />
            }
          />
        </Box>
        <Button
          styles={{ width: "auto", height: "56px", fontSize: "sm" }}
          variant={"solid_white"}
          text={`Qapp Premium ${T("dashboard.settings")}`}
          onClick={() => { }}
          leftIcon={
            <Icon
              name="qappPremium"
              iconStyles={{
                width: "20px",
                height: "20px",
                fill: "primary",
              }}
            />
          }
        />
      </Flex>
    </Flex>
  )
}

export default LaundryCommissionSettings
